export const NATIONALITIES = [
    'British', 'Irish', 'Polish', 'Romanian', 'Lithuanian', 'Bulgarian',
    'Portuguese', 'Italian', 'Spanish', 'Latvian', 'Indian', 'Nigerian',
    'Filipino', 'Ukrainian', 'French', 'German', 'Hungarian', 'Slovak',
    'Czech', 'Albanian', 'Afghan', 'Algerian', 'American', 'Angolan',
    'Argentine', 'Armenian', 'Australian', 'Austrian', 'Azerbaijani',
    'Bahraini', 'Bangladeshi', 'Belarusian', 'Belgian', 'Bolivian',
    'Bosnian', 'Botswanan', 'Brazilian', 'Burmese', 'Cambodian',
    'Cameroonian', 'Canadian', 'Chilean', 'Chinese', 'Colombian',
    'Congolese', 'Costa Rican', 'Croatian', 'Cuban', 'Cypriot', 'Danish',
    'Dominican', 'Dutch', 'Ecuadorian', 'Egyptian', 'Emirati', 'Eritrean',
    'Estonian', 'Ethiopian', 'Fijian', 'Finnish', 'Georgian', 'Ghanaian',
    'Greek', 'Guatemalan', 'Guyanese', 'Haitian', 'Honduran', 'Icelandic',
    'Indonesian', 'Iranian', 'Iraqi', 'Israeli', 'Ivorian', 'Jamaican',
    'Japanese', 'Jordanian', 'Kazakh', 'Kenyan', 'Kosovan', 'Kuwaiti',
    'Kyrgyz', 'Laotian', 'Lebanese', 'Liberian', 'Libyan', 'Luxembourgish',
    'Malaysian', 'Maltese', 'Mauritian', 'Mexican', 'Moldovan', 'Moroccan',
    'Mozambican', 'Namibian', 'Nepalese', 'New Zealand', 'Nicaraguan',
    'North Korean', 'North Macedonian', 'Norwegian', 'Omani', 'Pakistani',
    'Palestinian', 'Panamanian', 'Papua New Guinean', 'Paraguayan',
    'Peruvian', 'Qatari', 'Russian', 'Rwandan', 'Saudi', 'Senegalese',
    'Serbian', 'Sierra Leonean', 'Singaporean', 'Slovenian', 'Somali',
    'South African', 'South Korean', 'Sri Lankan', 'Sudanese', 'Swedish',
    'Swiss', 'Syrian', 'Taiwanese', 'Tajik', 'Tanzanian', 'Thai',
    'Trinidadian', 'Tunisian', 'Turkish', 'Turkmen', 'Ugandan',
    'Uruguayan', 'Uzbek', 'Venezuelan', 'Vietnamese', 'Yemeni', 'Zambian',
    'Zimbabwean', 'Other',
];
//# sourceMappingURL=nationalities.js.map